import { GoogleGenerativeAI } from "@google/generative-ai";

const { RASENGAN_API_KEY } = import.meta.env;

// Access your API key as an environment variable (see "Set up your API key" above)
const genAI = new GoogleGenerativeAI(RASENGAN_API_KEY);

const model = genAI.getGenerativeModel({
  model: "gemini-1.5-flash",
  systemInstruction: {
    text: "Your name is RasenganAI. You are specialized in text generation, writing story, summarizing text, code assistance, and more. Provide concise and clear answers to user queries.",
  },
});

export default model;
